import axios from 'axios';
import { authService } from '../services/auth';

export const BASE_URL = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_API_URL || 'https://api.osrouter.dev')
  : 'http://localhost:8000';

const allowed401s = ['/api/token/', '/api/token/refresh/'];

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.authorization = `Bearer ${token}`;
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !allowed401s.includes(originalRequest.url.replace(BASE_URL, ''))
    ) {
      originalRequest._retry = true;
      return postRequest(
        '/api/token/refresh/',
        { refresh: localStorage.getItem('refreshToken') },
        (response) => {
          localStorage.setItem('accessToken', response.data.access);
          return axios(originalRequest);
        },
        () => {
          localStorage.clear();
          window.location = `/login/?next=${encodeURIComponent(window.location.pathname)}`;
        }
      );
    }
    return Promise.reject(error);
  }
);

export const getRequest = (url, onSuccess, onError) =>
  axios.get(BASE_URL + url).then(onSuccess).catch(onError);

export const postRequest = (url, data, onSuccess, onError) =>
  axios.post(BASE_URL + url, data).then(onSuccess).catch(onError);

export const patchRequest = (url, data, onSuccess, onError) =>
  axios.patch(BASE_URL + url, data).then(onSuccess).catch(onError);

export const deleteRequest = (url, onSuccess, onError) =>
  axios.delete(BASE_URL + url).then(onSuccess).catch(onError);
